import tabs from './nav.vue';
// import foot from '../foot/foots.vue';
import Vue from 'vue'
const Tabs = {
    install: function() {
        Vue.component('Tabs', tabs)
            // Vue.component('Foot', foot)
    }
}
export default Tabs;